import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Achievement, AchievementLatest } from '../models';

export const achievementActions = createActionGroup({
    events: {
        'Get Next Achievement': emptyProps(),
        'Get Next Achievement Success': props<{ achievement: Achievement }>(),
        'Get Next Achievement Error': emptyProps(),

        'Get Latest Achievements': emptyProps(),
        'Get Latest Achievements Success': props<{ achievements: AchievementLatest[] }>(),
        'Get Latest Achievements Error': emptyProps(),

        Clear: emptyProps(),
    },
    source: 'Achievement',
});
